import { useState } from "react";
import PropTypes from "prop-types";
import Dialog from "../../dialogs/Dialog";
import Input from "../../forms/Input";
import "./DialogFilter.scss";

/**
 * Save filter dialog component
 * @module
 * @param {bool} isOpen - Is dialog open?
 * @param {func} handleClose - Handle close function
 * @param {func} handleConfirm - Handle confirm function
 * @param {string} error - Error
 */
const SaveFilter = (props) => {
  const { isOpen, handleClose, handleConfirm, error } = props;

  const [filterName, setFilterName] = useState("");

  const handleChange = (name, value) => {
    setFilterName(value);
  };

  const confirm = () => {
    handleConfirm(filterName);
    setFilterName("");
  };

  return (
    <Dialog isOpen={isOpen} onClose={handleClose} onConfirm={confirm} title="Uložiť filter">
      <div className="save-filter-dialog">
        {error && <div className="alert-filter-name">{error}</div>}
        <div className="form">
          <div>Názov filtra</div>
          <Input name={"filterName"} onChange={handleChange} value={filterName} />
        </div>
      </div>
    </Dialog>
  );
};

SaveFilter.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  error: PropTypes.string,
};

export default SaveFilter;
